// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"89GO0":[function(require,module,exports) {
require("fbb23a7b67a5eea0").register(JSON.parse('{"90jBb":"index.adb29d72.js","bCY05":"logo512.468c4f18.png","hol8q":"background.7652ee9a.svg","xj039":"paratime-selector-glow.428132fa.svg","5ONVS":"paratime-selector-globe.802ba314.svg","jInk4":"paratime-selector-glow-testnet.fa73b1cf.svg","kkydO":"paratime-selector-globe-testnet.3ff0ff18.svg","3JUoB":"help-screen-navigate.b873ec98.svg","2TrGk":"help-screen-pinch.de2c220f.svg","2hXmE":"help-screen-tap.4f34f182.svg","afwlC":"background-empty-state.a5413910.svg","1gndE":"oasis.3f0060d9.svg","k34lx":"eth.28f57e49.svg","gg6vW":"background-social.727c4ae1.png","iBg4R":"telegram.0ae1e870.svg","cv5Rb":"twitter.5906bfab.svg","1Pddm":"discord.e271280c.svg","grVHQ":"youtube.73dfde61.svg","2mjmE":"reddit.b42bab17.svg","eEmfX":"index.c486c91a.css"}'));

},{"fbb23a7b67a5eea0":"2axYw"}],"2axYw":[function(require,module,exports) {
"use strict";
var mapping = {};
function register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)mapping[keys[i]] = pairs[keys[i]];
}
function resolve(id) {
    var resolved = mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}]},["89GO0"], null, "parcelRequire27e2")

//# sourceMappingURL=index.f34020a2.js.map
